module.exports = __webpack_public_path__ + "SandeepKumar-58010cee.webp";